module.exports = __webpack_public_path__ + "static/media/optimmetrics.1fae67e4.png";